"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryButtonLink = exports.SecondaryButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hooks = require("../../hooks");
var _loadingSpinner = require("../loading-spinner");
var _shared = require("./shared");
var _mixins = require("../typography/mixins");
var _useDataAttributes = require("../../hooks/use-data-attributes");
var _excluded = ["ariaLabel", "children", "disabled", "loading", "onClick", "type"],
  _excluded2 = ["ariaLabel", "children", "disabled", "href"];
var SecondaryStyledButton = _styledComponents["default"].button.withConfig({
  displayName: "secondary-button__SecondaryStyledButton"
})(["", " padding:0.5rem 1.5rem;background-color:transparent;border:1px solid;border-color:", ";border-radius:", ";text-decoration:none;transition:background 0.15s ease 0s,color 0.15s ease 0s,box-shadow 0.15s ease 0s;box-sizing:border-box;position:relative;display:inline-block;line-height:1.5rem;max-width:100%;font-size:1rem;text-align:center;cursor:", ";user-select:none;color:", ";&:hover,&:focus{box-shadow:", ";border-color:", ";color:", ";}"], _mixins.mixins.fontFamily, function (props) {
  return props.$disabled ? props.$disabledColor : props.$color;
}, function (props) {
  return _shared.BORDER_RADIUS[props.$shape];
}, function (props) {
  return props.$disabled ? 'default' : 'pointer';
}, function (props) {
  return props.$disabled ? props.$disabledColor : props.$color;
}, function (props) {
  return props.$disabled ? 'none' : 'rgba(0, 0, 0, 0.3) 0 2px 6px';
}, function (props) {
  return props.$disabled ? props.$disabledColor : props.$hoverColor;
}, function (props) {
  return props.$disabled ? props.$disabledColor : props.$hoverColor;
});
var SecondaryButton = exports.SecondaryButton = function SecondaryButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    disabled = _ref.disabled,
    loading = _ref.loading,
    onClick = _ref.onClick,
    type = _ref.type,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var dataAttributes = (0, _useDataAttributes.useDataAttributes)(rest);
  var _useBonsai = (0, _hooks.useBonsai)(),
    buttonShape = _useBonsai.buttonShape,
    linkColor = _useBonsai.linkColor,
    secondaryFont = _useBonsai.secondaryFont;
  var disabledColor = (0, _shared.toDisabledColor)(linkColor);
  var hoverColor = (0, _shared.toHoverColor)(linkColor);
  return /*#__PURE__*/_react["default"].createElement(SecondaryStyledButton, (0, _extends2["default"])({
    type: type,
    "aria-label": ariaLabel,
    onClick: onClick,
    disabled: disabled,
    "aria-disabled": disabled,
    $color: linkColor,
    $shape: buttonShape,
    $disabledColor: disabledColor,
    $disabled: disabled,
    $font: secondaryFont,
    $hoverColor: hoverColor
  }, dataAttributes), loading ? /*#__PURE__*/_react["default"].createElement(_loadingSpinner.LoadingSpinner, {
    size: 'small'
  }) : children);
};
var SecondaryButtonLink = exports.SecondaryButtonLink = function SecondaryButtonLink(_ref2) {
  var ariaLabel = _ref2.ariaLabel,
    children = _ref2.children,
    disabled = _ref2.disabled,
    href = _ref2.href,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var dataAttributes = (0, _useDataAttributes.useDataAttributes)(rest);
  var _useBonsai2 = (0, _hooks.useBonsai)(),
    buttonShape = _useBonsai2.buttonShape,
    linkColor = _useBonsai2.linkColor,
    secondaryFont = _useBonsai2.secondaryFont;
  var disabledColor = (0, _shared.toDisabledColor)(linkColor);
  var hoverColor = (0, _shared.toHoverColor)(linkColor);
  return /*#__PURE__*/_react["default"].createElement(SecondaryStyledButton, (0, _extends2["default"])({
    as: "a",
    "aria-label": ariaLabel,
    href: href,
    $color: linkColor,
    $shape: buttonShape,
    $disabled: disabled,
    $disabledColor: disabledColor,
    $font: secondaryFont,
    $hoverColor: hoverColor
  }, dataAttributes), children);
};